import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Modal, notification, Row, Space, Table } from 'antd'
import _, { sum } from 'lodash'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { ThemeContext } from '../../../theme/ThemeContext'
import styles from '../MembersManagementPage.module.css'
// import { AddOrEditFormDetailModal } from './addOrEditDetailModal'

import { ExclamationCircleFilled } from '@ant-design/icons'
import { NavBar } from '../../../compnents/nav/NavBar'
import { useHistory, useLocation } from 'react-router-dom'
import { MemberCardColumns } from '../columns'
import { MemberCardQuery } from '../Query'
import { AddOrEditMemberCardModal } from './addOrEditMemberCardModal'
import { deleteMemberCard, getMemberCardList, unbindMemberCard } from '../MembersManagementPageSlice'
import { DateRangeType, getDateRange } from '../../../compnents/form/DateSelect'
import { BindMembersModal } from '../bindMemberModal'

export const MembersCardManagementPage = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const [head, tail] = getDateRange(DateRangeType.Today)

  const theme = useContext(ThemeContext)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [total, setTotal] = useState<any>()

  const [data, setData] = useState<any[]>([])

  const [id, setId] = useState<any>()

  // 会员卡绑定弹窗
  const [bindMembersVisible, setBindMembersVisible] = useState(false) // 新增会员弹窗

  const [cardData, setCardData] = useState<any>({})
  
  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10,
  })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const getDataList = () => {
    setPageLoading(true)
    dispatch(
      getMemberCardList({
        ...queries,
        timeHead: queries?.timeHead || head,
        timeTail: queries?.timeTail || tail,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    getDataList()
  }, [queries])

  return (
    <>
      <NavBar
        style={{ margin: '10px 20px 0 20px' }}
        where={['会员管理', '会员卡管理']}
        backtrace={{
          name: '会员管理',
          path: location?.state?.isMenu ? '/member' : '/statistics/outpatient',
          state: { selectKey: '3' },
          routeName: '会员管理',
        }}
      />
      <Col className={styles.contentDetail}>
        <Col
          className={styles.contentMain}
          style={{
            flex: 1,
            backgroundColor: theme.pn,
          }}
        >
          <MemberCardQuery
            loading={pageLoading}
            onValueChange={((v: any) => {
              setQueries({
                ...queries,
                ...v,
                current: 1,
              })
            })}
            addMemberCard={(() => {
              setIsModalVisible(true)
            })}
          />
          <EditableList
            loading={pageLoading}
            page={{
              items: data,
              current: queries.current || 1,
              size: queries.size || 10,
              total: total,
            }}
            columns={MemberCardColumns((text, t: any) => {
              if (text == 'delete') {
                Modal.confirm({
                  centered: true,
                  title: '确认操作',
                  content: (
                    <div>
                      <ExclamationCircleFilled
                        style={{ color: '#FFAE55', fontSize: 18 }}
                      />
                      &nbsp;是否确认删除？
                    </div>
                  ),
                  okText: '确认',
                  cancelText: '取消',
                  icon: null,
                  onOk: () => {
                    dispatch(deleteMemberCard({
                      id: t?.id,
                    }))
                      .then(unwrapResult)
                      .then(() => {
                        notification.success({
                          message: '操作成功',
                        })
                        getDataList()
                      })
                  },
                })
              } else if (text == 'edit') {
                setIsModalVisible(true)
                setId(t?.id)
              } else if (text == 'unbind') {
                Modal.confirm({
                  centered: true,
                  title: '确认操作',
                  content: (
                    <div>
                      <ExclamationCircleFilled
                        style={{ color: '#FFAE55', fontSize: 18 }}
                      />
                      &nbsp;是否确认解绑？
                    </div>
                  ),
                  okText: '确认',
                  cancelText: '取消',
                  icon: null,
                  onOk: () => {
                    dispatch(unbindMemberCard({
                      memberCardId: t?.id,
                    }))
                      .then(unwrapResult)
                      .then(() => {
                        notification.success({
                          message: '操作成功',
                        })
                        getDataList()
                      })
                  },
                })
              } else if (text == 'bind') {
                setBindMembersVisible(true)
                setCardData(t)
              }
            }, (queries.size || 10) * ((queries.current || 1) - 1))}
            onChangePage={(current: any, size: any) => {
              setQueries({
                ...queries,
                current,
                size,
              })
            }}
          />
        </Col>
      </Col>
      <AddOrEditMemberCardModal
        editId={id}
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false)
          getDataList()
          setId('')
        }}
        onOk={() => {
          setIsModalVisible(false)
          getDataList()
          setId('')
        }}
      />
      <BindMembersModal // 会员卡绑定
        cardData={cardData}
        visible={bindMembersVisible}
        onCancel={() => {
          setBindMembersVisible(false)
          setCardData({})
        }}
        onOk={() => {
          setBindMembersVisible(false)
          getDataList()
          setCardData({})
        }}
      />
    </>
  )
}
